module.exports = __webpack_public_path__ + "img/spinner_white.ac098de2.gif";